<script lang="ts">
  import type {
    AggregateRating,
    FAQPage,
    Organization,
    SoftwareApplication,
    WebSite,
  } from '../types/structuredData'

  export let schema:
    | AggregateRating
    | SoftwareApplication
    | Organization
    | FAQPage
    | WebSite

  $: modifiedSchema = JSON.stringify({
    ...schema,
    '@context': 'https://schema.org',
  })

  // eslint-disable-next-line no-useless-escape
  $: schemaScript = `<script type=\"application/ld+json\">${modifiedSchema}<\/script>`
</script>

<!--eslint-disable-next-line svelte/no-at-html-tags-->
{@html schemaScript}
